import { createContext, useCallback, useMemo, useState } from 'react';

import Component from '../../types/Component';
import storageValue from '../../utils/storageValue';

export type CustomerInfoType = {
	name?: string;
	email?: string;
	phone?: string;
};

export const CustomerInfoProviderContext = createContext({
	state: {} as CustomerInfoType,
	setState: (() => null) as (newState: CustomerInfoType) => void,
});

const CUSTOMER_INFO_KEY = 'customerInfo';

const CustomerInfoProvider: Component<{}> = ({ children }) => {
	const storageState = useMemo(() => {
		try {
			return JSON.parse(storageValue(CUSTOMER_INFO_KEY)) ?? {};
		} catch (e: any) {
			return {};
		}
	}, []);

	const [state, setState] = useState(storageState || {});

	const updateState = useCallback(
		(newState: CustomerInfoType) => {
			setState(newState);
			storageValue(CUSTOMER_INFO_KEY, JSON.stringify(newState));
		},
		[setState]
	);

	return (
		<CustomerInfoProviderContext.Provider value={{ state, setState: updateState }}>
			{children}
		</CustomerInfoProviderContext.Provider>
	);
};

export default CustomerInfoProvider;
